import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";

export const modulesApi = createApi({
    reducerPath: "modulesApi",
    tagTypes: ["modules"],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: (build) => ({
        getModules: build.query({
            query: (data) => ({
                url: api.modules.getModules(),
                method: "GET",
                params: data,
            }),
            providesTags: ["modules"],
        }),
        getSingleModule: build.query({
            query: ({name, ...data}) => ({
                url: api.modules.getSingleModule(name),
                method: "GET",
                params: data,
            }),
            providesTags: ["modules"],
        }),
        updateModules: build.mutation({
            query: ({id, ...data}) => ({
                url: api.modules.updateModules(id),
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ["modules"],
        }),
    }),
});

export const { useGetSingleModuleQuery } = modulesApi;
